import * as React from "react";

import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";

import { Footer } from "./Footer";
import { TopBar } from "./TopBar";
import { SideBar } from "./SideBar";
import { Container } from "./Container";

export interface Props {
  childrenInContainer?: boolean;
}

export const PageWrapper = (props: React.PropsWithChildren<Props>) => {
  const { childrenInContainer, children } = props;

  const [sideBarOpen, setSideBarOpen] = React.useState(false);

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return (
    <Box>
      <AppBar position="fixed" elevation={trigger ? 2 : 0} color="inherit">
        <Container paddingY={1}>
          <TopBar onSideBarOpen={() => setSideBarOpen(true)} />
        </Container>
      </AppBar>
      <SideBar open={sideBarOpen} onClose={() => setSideBarOpen(false)} />
      <Box mt={{ xs: 12, sm: 14, md: 16 }}>
        <main>
          {childrenInContainer ? <Container>{children}</Container> : children}
        </main>
      </Box>
      <Container py={4}>
        <Footer />
      </Container>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/PageWrapper.tsx